// extracted by mini-css-extract-plugin
export default {"navigationLinkBoxContainer":"NavigationLinkBox_navigationLinkBoxContainer__VKdTw"};